import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 3rem;

  > p {
    font-size: 1rem;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const ContentForm = styled.div`
  max-width: 380px;
  width: 100%;

  > div {
    margin-top: 1rem;
  }
`;

export const ContentButton = styled.div`
  margin-top: 2rem;
  max-width: 380px;
  width: 100%;
`;
